import type { FC } from 'react';
import { InfiniteScrollInnerWrapper, InfiniteScrollOuterWrapper } from './InfiniteScroll.styled';

export const InfiniteScroll: FC = ({ children }) => {
    return (
        <InfiniteScrollOuterWrapper>
            <InfiniteScrollInnerWrapper>{children}</InfiniteScrollInnerWrapper>
            <InfiniteScrollInnerWrapper>{children}</InfiniteScrollInnerWrapper>
        </InfiniteScrollOuterWrapper>
    );
};

InfiniteScroll.displayName = 'InfiniteScroll';
